import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setRole } from "../redux/slices/role";
import { rl } from "../constants";
import { API_BASE_URL } from "../config";
import { setRooms } from "../redux/slices/websocket";

const useAuth = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const signIn = async (username, password) => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username, password }),
    };
    const response = await fetch(
      `${API_BASE_URL}/api/authentication`,
      requestOptions
    );
    const responseData = await response.json();

    if (responseData.status === 1) {
      // Login successful
      sessionStorage.setItem("token", responseData.data.token);
      sessionStorage.setItem("nome", responseData.data.nome);
      sessionStorage.setItem("cognome", responseData.data.cognome);
      sessionStorage.setItem("agenzia", responseData.data.agenzia);
      sessionStorage.setItem("nomeAvatar", responseData.data.nomeAvatar);
      sessionStorage.setItem("roomsName", responseData.data.roomsName);
      dispatch(setRooms(responseData.data.roomsName));
      dispatch({ type: "websocket/connect", payload: API_BASE_URL });

      return true;
    } else {
      // Login failed
      return false;
    }
  };

  const signOut = async () => {
    const token = sessionStorage.getItem("token");

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + token,
      },
      body: JSON.stringify({ token }),
    };
    await fetch(`${API_BASE_URL}/api/logout`, requestOptions);
    dispatch({ type: "websocket/disconnect" });

    sessionStorage.clear();
    navigate("/auth/sign-in");
  };

  async function getData(data) {
    const token = sessionStorage.getItem("token");

    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
        body: JSON.stringify({ token, data: data }),
      };

      const response = await fetch(
        `${API_BASE_URL}/api/getData`,
        requestOptions
      );
      const responseData = await response.json();

      if (responseData.status === -1) {
        sessionStorage.clear();
        navigate("/auth/sign-in");
      }

      switch (data.action) {
        case "menu":
          return responseData;
        case "usersList":
        case "toponimi":
        case "provincie":
        case "comuni":
        case "cap":
        case "nazioni":
        case "tipologiacontatti":
        case "rcAutoGetFilter":
        case "rcAutoGetFilterValue":
        case "getPreviewInfo":
          return responseData;
        default:
          return undefined;
      }
    } catch (error) {
      return error;
    }
  }

  async function setData(action, data) {
    const token = sessionStorage.getItem("token");

    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
        body: JSON.stringify({ token, action, data }),
      };

      const response = await fetch(
        `${API_BASE_URL}/api/setData`,
        requestOptions
      );
      const responseData = await response.json();

      if (responseData.status === -1) {
        sessionStorage.clear();
        navigate("/auth/sign-in");
      }

      return responseData;
    } catch (error) {
      return error;
    }
  }

  async function getUserInfo(iduser) {
    const token = sessionStorage.getItem("token");

    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
      };

      if (iduser) {
        requestOptions.body = JSON.stringify({ iduser: iduser });
      }
      const response = await fetch(
        `${API_BASE_URL}/api/userGetInfo`,
        requestOptions
      );
      const responseData = await response.json();

      if (responseData.status === -1) {
        sessionStorage.clear();
        navigate("/auth/sign-in");
      }

      return responseData;
    } catch (error) {
      return error;
    }
  }

  /* const getRCAutoDetails = async (idTarga) => {
    const token = sessionStorage.getItem("token");

    try {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json",authorization : "Bearer " + token },
        body: JSON.stringify({
          token,
          data: {
            idUIDTarga: idTarga,
          },
        }),
      };

      const response = await fetch(
        `${API_BASE_URL}/api/rcAutoGetDetails`,
        requestOptions
      );
      const responseData = await response.json();

      if (responseData.status === -1) {
        sessionStorage.clear();
        navigate("/auth/sign-in");
      }

      return responseData;
    } catch (error) {
      return error;
    }
  }; */

  const getRCAutoDetails = async (idTarga) => {
    const token = sessionStorage.getItem("token");

    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          token,
          data: {
            idUIDTarga: idTarga,
          },
        }),
      };

      const response = await fetch(
        `${API_BASE_URL}/api/rcAutoGetDetails`,
        requestOptions
      );
      const responseData = await response.json();

      if (responseData.status === -1) {
        sessionStorage.clear();
        navigate("/auth/sign-in");
      }

      return responseData;
    } catch (error) {
      return error;
    }
  };

  async function sendAnagraficaData(idUser, data) {
    const token = sessionStorage.getItem("token");

    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
        body: JSON.stringify({ token, idUser, data }),
      };

      const response = await fetch(
        `${API_BASE_URL}/api/userSetInfo`,
        requestOptions
      );
      const responseData = await response.json();

      if (responseData.status === -1) {
        sessionStorage.clear();
        navigate("/auth/sign-in");
      }

      return responseData;
    } catch (error) {
      return error;
    }
  }

  async function getRcData(
    rowsPages,
    pageNumbers,
    idUidFlotta,
    filterData,
    idTipologia
  ) {
    const token = sessionStorage.getItem("token");

    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          token,
          rowsPages,
          pageNumbers,
          idUidFlotta,
          ...filterData,
          idTipologia,
        }),
      };

      const response = await fetch(
        `${API_BASE_URL}/api/rcAutoGetList`,
        requestOptions
      );
      const responseData = await response.json();

      if (responseData.status === -1) {
        sessionStorage.clear();
        navigate("/auth/sign-in");
      }

      return responseData;
    } catch (error) {
      return error;
    }
  }

  async function rcAutoNewUpdate(data, action) {
    const token = sessionStorage.getItem("token");

    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
        body: JSON.stringify({ token, data, action }),
      };

      const response = await fetch(
        `${API_BASE_URL}/api/rcAutoNewUpdate`,
        requestOptions
      );
      const responseData = await response.json();

      if (responseData.status === -1) {
        sessionStorage.clear();
        navigate("/auth/sign-in");
      }

      return responseData;
    } catch (error) {
      return error;
    }
  }

  const getFleetData = async (
    rowsPages,
    pageNumbers,
    nomeFlotta = "",
    idTipologia = 1
  ) => {
    const token = sessionStorage.getItem("token");

    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          rowsPages,
          pageNumbers,
          nomeFlotta,
          idTipologia,
        }),
      };

      const response = await fetch(
        `${API_BASE_URL}/api/flotteGetList`,
        requestOptions
      );
      const responseData = await response.json();

      if (responseData.status === -1) {
        sessionStorage.clear();
        navigate("/auth/sign-in");
      }

      return responseData;
    } catch (error) {
      return error;
    }
  };

  const flotteNewUpdate = async (nomeFlotta, numeroTarghe, data) => {
    const token = sessionStorage.getItem("token");

    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
        body: JSON.stringify({ token, nomeFlotta, numeroTarghe, data }),
      };

      const response = await fetch(
        `${API_BASE_URL}/api/flotteNewUpdate`,
        requestOptions
      );
      const responseData = await response.json();

      if (responseData.status === -1) {
        sessionStorage.clear();
        navigate("/auth/sign-in");
      }

      return responseData;
    } catch (error) {
      return error;
    }
  };

  const flotteDownload = async (idUidFlotta) => {
    const token = sessionStorage.getItem("token");

    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
        body: JSON.stringify({ token, idUidFlotta }),
      };

      const response = await fetch(
        `${API_BASE_URL}/api/flotteDownload`,
        requestOptions
      );
      const responseData = await response.json();

      if (responseData.status === -1) {
        sessionStorage.clear();
        navigate("/auth/sign-in");
      }

      return responseData;
    } catch (error) {
      return error;
    }
  };

  return {
    signIn,
    signOut,
    getData,
    getUserInfo,
    setData,
    sendAnagraficaData,
    getRcData,
    getRCAutoDetails,
    rcAutoNewUpdate,
    getFleetData,
    flotteNewUpdate,
    flotteDownload,
  };
};

export default useAuth;
